import { type ServiceType } from '../types/ServiceType';

export const OrderDeliveryServicesTitles: Record<ServiceType, string> = {
    YANDEX_DELIVERY: 'Яндекс Доставка',
    CDEK: 'CDEK',
    META_SHIP_RUSSIAN_POST: 'Почта России',
    META_SHIP_PECOM: 'ПЭК',
    META_SHIP_DALLI: 'Dalli',
    YANDEX_MARKET_FBO: 'Яндекс маркет FBO',
    SELF: 'Самовывоз',
    HOLODILNIK: '',
    MERCHANT_SHIP: 'Собственная доставка',
    OZON: 'Ozon',
} as const;
